import React from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"

import LinkArrow from "images/icons/arrow.svg"
import { brandRules } from "utils/brand"
import { mapPageHit } from "utils/algolia"

const Frame = styled.div`
  height: 458px;

  .cover {
    transition: all 0.15s ease-out;
  }

  &:hover {
    .darken {
      opacity: 0.4;
    }
  }

  .main {
    ${tw`p-4 bg-white font-body flex flex-col items-center flex-shrink`}
    border-radius: 0 0 5px 5px;
    height: 229px;
  }

  ais-highlight-0000000000 {
    color: #3498db;
  }
`

const FeaturedImage = styled.div`
  margin: 0;
  position: relative;
  padding: 0;
  width: 100%;
  z-index: 1;

  .icon {
    position: absolute;
    left: calc(50% - 41.5px);
    top: calc(50% - 41.5px);
    height: 83px;
    width: 83px;
    z-index: 2;
  }
`

const CoverImage = styled.div`
  height: 100%;
  width: 100%;
  z-index: 1;
  background-image: ${(props) => (props.bg ? `url(${props.bg})` : "")};
  background-size: cover;
  background-position: center;

  .darken {
    ${tw`bg-black`}
    height: 100%;
    width: 100%;
    opacity: 0.7;
    position: absolute;
    transition: opacity 0.2s;
  }
`

const Title = styled.div`
  ${tw`font-display font-bold text-grey-10 my-1`}
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  max-height: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const Excerpt = styled.div`
  ${tw`font-body text-grey-5 my-1`}
  font-size: 13px;
  line-height: 22px;
  height: 108px;
  display: -webkit-box;
  text-align: center;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  .understrap-read-more-link {
    display: none;
  }
`

const PageLink = ({ children, page, ...rest }) => {
  const { external, to } = page

  if (external) {
    return (
      <a href={to} {...rest}>
        {children}
      </a>
    )
  } else {
    return (
      <Link to={to} {...rest}>
        {children}
      </Link>
    )
  }
}

const PageCard = ({ page: pageHit, settings }) => {
  const page = mapPageHit(pageHit, settings)
  const imageUrl = `${process.env.GATSBY_ASSETS_BASE_URL}resize=w:780,fit:clip,align:center/output=format:jpg/cache=expiry:max/compress=metadata:false/${page.imageHandle}`

  return (
    <Frame className="my-2 px-2 w-full flex flex-col m:w-1/2 l:w-1/4">
      <PageLink page={page} className="flex flex-col flex-grow">
        <FeaturedImage className="bg-grey-15 flex flex-col flex-grow overflow-hidden">
          <CoverImage bg={imageUrl} className="flex flex-grow cover" />
        </FeaturedImage>
        <div className="main">
          <Title
            className="overflow-hidden"
            dangerouslySetInnerHTML={{
              __html: page._highlightResult.title.value,
            }}
          />
          <div className="flex-grow flex flex-col items-center">
            <Excerpt
              dangerouslySetInnerHTML={{
                __html: `<span>${brandRules(
                  page._highlightResult.excerpt?.value || "",
                  true
                )}</span>`,
              }}
            />
            <img
              src={LinkArrow}
              alt="link arrow"
              width={36}
              height={17}
              className="my-2"
            />
          </div>
        </div>
      </PageLink>
    </Frame>
  )
}

export default PageCard
